<template>
  <div id="legalNotice" class="d-flex justify-content-left align-items-center">
    <div>
      <span
        v-for="(legalNotice) in legalNoticeLgLeft"
        v-bind:key="legalNotice.ta_value"
      >{{ legalNotice.ta_value }}</span>
      <span
        v-for="(legalNotice) in legalNoticeLgMiddle"
        v-bind:key="legalNotice.ta_value"
      >{{ legalNotice.ta_value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TribeRatesHorizontalV1LegalNoticeLeft",
  props: {
    legalNoticeLgLeft: Array,
    legalNoticeLgMiddle: Array,
  },
  methods: {
    rawHtml(value) {
      return value;
    },
  },
};
</script>


<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../_tribe.scss";

#legalNotice {
  font-family: "Brown";
  @include fontSize(25);
  line-height: 1rem;
  text-transform: initial;

  position: absolute;
  @include topPercent(950);
  @include widthPercent(1547);
  @include heightPercent(250);
  @include leftPercent(100);

  span + span:not(:empty):before {
    content: "- ";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tribe/rates/horizontal/v1/legalNotice.vue